export default {
 		"Contact.index.547366-0": "选择纵横四海实现企业数字化转型",
		"Contact.index.547366-1": "您的称呼",
		"Contact.index.547366-2": "您的手机号码",
		"Contact.index.547366-3": "其他联系方式",
		"Contact.index.547366-4": "提交预约咨询",
		"Contact.index.547366-5": "全国咨询热线：",
		"Contact.index.547366-6": "解决方案",
		"Contact.index.547366-7": "软件研发服务",
		"Contact.index.547366-8": "行业解决方案",
		"Contact.index.547366-9": "数字化战略咨询",
		"Contact.index.547366-10": "关于纵横四海",
		"Contact.index.547366-11": "公司官网",
		"Contact.index.547366-12": "纵横四海公众号",
		"Contact.index.547366-13": "官方抖音店铺",
		"Contact.index.547366-14": "© 2026 纵横四海 版权所有 | 沪ICP备2026002949号-1",
		"Contact.index.547366-15": "注册地址：上海市长宁区华阳路"
}
